<template>
  <div>
    <div class="offer-sale-base">
      <div class="d-flex flex-row align-center" :style="isMobile ? { gap: '8px' } : { gap: '8px', minWidth: '25vw' }">
        <div class="img-container">
          <img v-if="imageUrl && imageUrl.length" :src="imageUrl" alt="" width="35px" height="35px" />
          <mf-icon v-else>image_not_supported</mf-icon>
        </div>
        <div v-if="isGroup" class="d-flex flex-column">
          <span class="group-products-label">Grupo de produtos</span>
          <span class="group-products-name">{{ offerSale.name }}</span>
          <span v-if="isActivable" :class="activationClass">{{ activationDate }}</span>
        </div>
        <div v-else class="d-flex flex-column">
          <span class="offer-sale-name">{{ offerSale.name }}</span>
          <span v-if="isActivable" :class="activationClass">{{ activationDate }}</span>
        </div>
      </div>

      <slot name="line-1" />
      <slot name="line-2" />
      <slot name="line-3" />
    </div>

    <v-expansion-panels v-if="isGroup" v-model="groupOpen" flat tile>
      <v-expansion-panel>
        <v-expansion-panel-header class="group-header">
          <span>{{ offerSale[type].length }} produtos no grupo</span>
          <template v-slot:actions>
            <v-icon color="marca-0-l30"> $expand </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="group-content">
          <div v-for="product in offerSale[type]" :key="product.sku" class="d-flex flex-row align-center group-item">
            <div class="img-container">
              <img v-if="product.image_url && product.image_url.length" :src="product.image_url" alt="" width="100%" />
              <mf-icon v-else>image_not_supported</mf-icon>
            </div>
            <div class="d-flex flex-column">
              <span class="product-in-group-name">{{ product.name }}</span>
              <offer-sale-line :line-items="productInGroupInfo(product)" />
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import OfferSaleLine from './OfferSaleLine.vue'
import DateTime from 'luxon'

export default {
  name: 'OfferSaleBase',
  components: {
    OfferSaleLine,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    groupOpen: false,
  }),
  computed: {
    imageUrl() {
      return this.isGroup ? this.offerSale.group_image_url : this.offerSale.image_url
    },
    activationDate() {
      if (this.offerSale.activated_at) {
        return `Ativado em: ${DateTime.fromISO(this.offerSale.activated_at).toFormat('dd/MM/yyyy - HH:mm')}`
      }
      return 'Informações de ativação desconhecidas.'
    },
    activationClass() {
      if (this.offerSale.activated_at) {
        return 'offer-activated'
      }
      return 'offer-not-activated'
    },
  },
  methods: {
    productInGroupInfo(product) {
      return [
        {
          label: 'SKU',
          value: product.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: product.ean,
          format: 'text',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-sale-base {
  background-color: $cinza-l90;
  padding: 8px 8px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid $cinza-l80;

  .offer-sale-name {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    color: $cinza-d10;
  }

  .group-products-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.4px;
    color: $cinza-l30;
  }

  .group-products-name {
    font-size: 14px;
    font-weight: 700;
    line-height: 16.8px;
    color: $cinza-d10;
  }
}

.img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;

  & img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
}

.product-in-group-name {
  font-size: 12px;
  font-weight: 700;
  line-height: 14.4px;
  color: $cinza-d10;
}

.group-header {
  font-size: 14px;
  font-weight: 700;
  padding: 12px 16px 12px 16px;
  background-color: $cinza-l80;
  color: $marca-0-l30;
  border-bottom: 1px solid #d7d8d9;
}

.group-content {
  background-color: $cinza-l80;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.group-item {
  padding: 12px 8px 12px 8px !important;
  border-bottom: 1px solid #d7d8d9;
  gap: 16px;
}

.offer-activated {
  font-size: 12px;
  color: $marca-0-l30;
}

.offer-not-activated {
  font-size: 12px;
  color: $cinza-l10;
}

@media screen and (min-width: 1024px) {
  .offer-sale-base {
    flex-direction: row;
    flex-wrap: wrap;
    background-color: white;
    gap: 72px;
  }
}
</style>
